import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef, SimpleChanges, AfterViewChecked, AfterViewInit, AfterContentInit } from '@angular/core';
import { MainService } from '../services/delavci/main.service';
import { MonitorService } from '../services/delavci/monitor/monitor.service';
import { MapModel } from '../models/MapModel';
import { MapListModel } from '../models/MapListModel';
import { MapDetailsList } from '../models/MapDetailsList';
import { MapDetailsServerList } from '../models/MapDetailsServerList';
import { Router, RouterLink, Scroll, Event } from '@angular/router';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { ViewportScroller } from '@angular/common';
import { filter } from 'rxjs/operators';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-monitor',
  templateUrl: './monitor.component.html',
  styleUrls: ['./monitor.component.css']
})
export class MonitorComponent implements OnInit, OnDestroy, AfterViewChecked {

  public mapListModel: MapListModel;
  public globalMap: Array<MapModel> = [];
  public slicedMap: Array<MapModel> = [];
  public firstMapCall: Array<MapModel> = [];
  public map: MapModel;
  public voiceToggle;
  public ticks: number;
  public audio = new Audio();
  public submitted;
  public mapDetailsList: MapDetailsList;
  public selectedTableRow: MapModel;
  public selectedColorTableRow: string;
  public mapDetailsServerList: MapDetailsServerList;
  public intervalId;
  public spinner = true;
  public nastavitveFromService = false;
  public globalMapAfterFilter: Array<MapModel> = [];
  public f ;
  public slicedMapGlobal = [];
  public filtrirajKategorija;
  public checkboxesFilter = [];
  public values: string;
  public isUpdateTimeSet: boolean;
  public initialRedServers: string[] = [];
  public isFirstTime = true;
  public intervalCounter = 0;

  subscription: Subscription;
  @ViewChild('tableHeight', {static: false}) tableHeight: any;
  public tableHeightValue;
  constructor(private mainService: MainService, private monitorService: MonitorService, private router: Router, private viewportScroller: ViewportScroller) {

  }

  ngOnInit() {
    this.monitorService.currentFilterObject.subscribe(data => {
      if(data) {
        this.checkboxesFilter = data[0].checkboxesFilter;
        this.filtrirajKategorija = data[1].filtrirajKategorijo;
        this.values = data[2].textFilter;
        this.updateTable();
      }

    });
    if (this.monitorService.currentSoundSettingValue == null) {
      this.voiceToggle = true;
    } else {
      this.voiceToggle = this.monitorService.currentSoundSettingValue;
    }

    this.monitorService.monitorData(this.mainService.currentUsernameValue)
      .subscribe(data => {
        this.initialRedServers = this.mapListModel.redMap.map(server => server.KEY); 
        console.log("initialRedServers: " + this.initialRedServers);
      });

    sessionStorage.clear();
    this.f = this.monitorService.currentFontSizeValue;
    this.mainService.nastavitveClickBool.subscribe( message => this.nastavitveFromService = message);
    this.mainService.changeHref(this.router.url);

    this.updateTable();
    this.filterInput();
    this.newInterval();
    this.onFontSizeChange();
    this.firstMapCall = this.globalMap;

    const monitorSessionRow = this.monitorService.currentMonitorRowPositionValue;
    const monitorSessionRowFilter = this.monitorService.currentFilterMonitorRowPositionValue;
    let selectedRow = Number(monitorSessionRow);
    let filterRow = Number(monitorSessionRowFilter);
    let i;
    if (filterRow != undefined && selectedRow != undefined && filterRow != 0) {
      if ( (selectedRow - filterRow) === 0 || (selectedRow - filterRow) < 0) {
        i = 0;
      } else {
        i = selectedRow-filterRow-1;
      }
    } else {
      if ( selectedRow > 10) {
        i = i - 6;
      } else if ( i > 5) {
        i = i - 5;
      }
    }
    if (selectedRow && i != 0) {
      setTimeout( function() {
        var elmnt = document.getElementById('row' + i);
        elmnt.scrollIntoView();
      }, 500);
    }


  }

  ngAfterViewChecked() {

  }

  //message iz child componenta Setting-bar-component.html
  getSubmitted(message: boolean) {
    this.submitted = message;
    this.f = this.monitorService.currentFontSizeValue;
    this.onFontSizeChange();
  }

  //message iz child componenta Setting-bar-component.html
  getVoiceToggle(soundSetting: boolean) {
    this.voiceToggle = soundSetting;
  }

  //interval ki odšteva 10 sekund, če nimamo v localstorage currentUpdateTimeValue, drugače pa je nastavlen glede na tisti value
  newInterval() {


    if (Number(this.monitorService.currentUpdateTimeValue) != 0) {
       this.isUpdateTimeSet = true;
       this.ticks = Number(this.monitorService.currentUpdateTimeValue);
    } else {
      this.isUpdateTimeSet = false;
      this.ticks = 10;
    }

    this.intervalId = setInterval(() => {
      this.ticks = this.ticks - 1;

      this.monitorService.newTimerTick(this.ticks);
      if (this.ticks === 0) {
        this.filterInput();
        this.updateTable();
        if (this.isUpdateTimeSet) {
          this.ticks = Number(this.monitorService.currentUpdateTimeValue);
      } else {
          this.ticks = 10;
        }
      }
    }, 1000);

  }

  //uniči interval in audio
  ngOnDestroy() {
    if (this.audio) {
      this.audio.pause();
      this.audio = null;
    }
    clearInterval(this.intervalId);
  }

  sendVoice() {
    if (this.voiceToggle && this.audio) {
      this.audio.src = '/assets/audio/failure.ogg';
      this.audio.loop = true; 
      this.audio.load();
      this.audio.play();
  
      setTimeout(() => {
        this.audio.loop = false; 
        this.audio.pause();
        this.audio.currentTime = 0; 
      }, 9000); // 10000 milliseconds = 10 seconds
    }
  }

  //update tabele in sortiranje
  updateTable() {
    this.monitorService.monitorData(this.mainService.currentUsernameValue)
    .subscribe(data => {
      this.mapListModel = data;
      // if (this.mapListModel.redMap.length != 0) {
      //   this.sendVoice();
      // }

      const currentRedServers = this.mapListModel.redMap.map(server => server.KEY);
      console.log("initialRedServers: " + currentRedServers);

      const isNewRedServer = currentRedServers.some(serverId => !this.initialRedServers.includes(serverId));
      console.log("initialRedServers: " + isNewRedServer);

      if (isNewRedServer && !this.isFirstTime) {
        this.sendVoice(); 
      }

      this.initialRedServers = currentRedServers;

      this.mapListModel.workingMap = this.sortTableRows(this.mapListModel.workingMap);
      this.mapListModel.redMap = this.sortTableRows(this.mapListModel.redMap);
      this.mapListModel.orangeMap = this.sortTableRows(this.mapListModel.orangeMap);
      this.mapListModel.greenMap = this.sortTableRows(this.mapListModel.greenMap);

      this.globalMap = [];

      for (var i = 0; i < this.mapListModel.workingMap.length; i++) {
        this.mapListModel.workingMap[i].status = 'gray';
        if (this.globalMap === undefined) {
          this.globalMap[0] = this.mapListModel.workingMap[i];
        } else {
          this.globalMap.push(this.mapListModel.workingMap[i]);
        }
      }

      for (let i = 0; i < this.mapListModel.redMap.length; i++) {
        this.mapListModel.redMap[i].status = 'red';
        if (this.globalMap === undefined) {
          this.globalMap[0] = this.mapListModel.redMap[i];
        } else {
          this.globalMap.push(this.mapListModel.redMap[i]);
        }
      }

      for (let i = 0; i < this.mapListModel.orangeMap.length; i++) {
        this.mapListModel.orangeMap[i].status = 'orange';
        if (this.globalMap === undefined) {
          this.globalMap[0] = this.mapListModel.orangeMap[i];
        } else {
          this.globalMap.push(this.mapListModel.orangeMap[i]);
        }
      }

      for (let i = 0; i < this.mapListModel.greenMap.length; i++) {
        this.mapListModel.greenMap[i].status = 'green';
        if (this.globalMap === undefined) {
          this.globalMap[0] = this.mapListModel.greenMap[i];
        } else {
          this.globalMap.push(this.mapListModel.greenMap[i]);
        }
      }

      if (this.isFirstTime) {
        this.isFirstTime = false;
      }

      this.firstMapCall = this.globalMap;
      this.checkCheckboxFilter();
      this.filterInput();
    }
    , error => {
      console.log(error);
    });

    this.spinner = false;

}

//sortira tabelo, tako da je na začetku gray map -> red map -> orange map -> green map. Poleg tega je sortirano po abecedi
  sortTableRows(unsortedArray: Array<MapModel>) {
    let sortedArray: Array<MapModel>;
    sortedArray = unsortedArray.slice(0);
    sortedArray.sort((left, right) => {
    if (left.SERV_NAMESMALL.toUpperCase() < right.SERV_NAMESMALL.toUpperCase()) {
      return -1;
    }

    if (left.SERV_NAMESMALL.toUpperCase() > right.SERV_NAMESMALL.toUpperCase()) {
      return 1;
    }

    return 0;
    });
    sortedArray.sort((left, right) => {
      if ((left.SERV_NAMESMALL.toUpperCase() == right.SERV_NAMESMALL.toUpperCase())) {
        if (left.MODU_NAMESMALL.toUpperCase() < right.MODU_NAMESMALL.toUpperCase()) {
          return -1;
        }
      }

      if ((left.SERV_NAMESMALL.toUpperCase() == right.SERV_NAMESMALL.toUpperCase())) {
        if (left.MODU_NAMESMALL.toUpperCase() > right.MODU_NAMESMALL.toUpperCase()) {
          return 1;
        }
      }
      return 0;
      });

    sortedArray.sort((left, right) => {
      if ((left.SERV_NAMESMALL.toUpperCase() == right.SERV_NAMESMALL.toUpperCase())) {
        if (left.METHOD.toUpperCase() < right.METHOD.toUpperCase()) {
          return -1;
        }
      }
      if ((left.SERV_NAMESMALL.toUpperCase() == right.SERV_NAMESMALL.toUpperCase())) {
        if (left.METHOD.toUpperCase() > right.METHOD.toUpperCase()) {
          return 1;
        }
      }
      return 0;
      });

    return sortedArray;
  }

 //prikaže podrobnosti tabele
 showMore(tableRow: MapModel, color: string, i) {
  this.spinner = true;
  this.selectedTableRow = tableRow;
  this.selectedColorTableRow = color;

  //i je index vrstice
  this.monitorService.setCurrentMonitorRowPosition(i);
  this.monitorService.newTableRow(this.selectedTableRow);
  this.router.navigate(['/monitor-item']);
}


onFontSizeChange() {
  this.f = this.monitorService.currentFontSizeValue;
  if (this.f === null) {
    this.f = 20;
  }
}



filterInput() {
  this.slicedMapGlobal = [];
  if (this.monitorService.currentFilterTextValue != undefined && this.checkboxesFilter.length != null && this.values != undefined) {
    this.checkCheckboxFilter();
    for (let i = 0; i < this.globalMap.length; i++) {

      if (this.filtrirajKategorija === 'Serv') {
        if (!(this.globalMap[i].SERV_NAMESMALL.toUpperCase().startsWith(this.values.toUpperCase()))) {
        } else {
          this.slicedMapGlobal.push(this.globalMap[i]);
        }
      } else if (this.filtrirajKategorija === 'Modu') {
        if (!(this.globalMap[i].MODU_NAMESMALL.toUpperCase().startsWith(this.values.toUpperCase()))) {
        } else {
          this.slicedMapGlobal.push(this.globalMap[i]);
        }
      } else if (this.filtrirajKategorija === 'METHOD') {
        if (!(this.globalMap[i].METHOD.toUpperCase().startsWith(this.values.toUpperCase()))) {
        } else {
          this.slicedMapGlobal.push(this.globalMap[i]);
        }
      }
    }
    if(this.slicedMapGlobal.length != 0) {
      this.globalMap = this.slicedMapGlobal;

    }
  }

  this.monitorService.setCurrentGlobalMap(this.globalMap);

}

checkCheckboxFilter() {
    let checkboxFilterArray: Array<MapModel> = [];
    let notAllAreFalse = false;
    for(let j = 0; j < this.checkboxesFilter.length; j++) {
      if (this.checkboxesFilter[j].name === 'green'
       && this.checkboxesFilter[j].selected) {
         notAllAreFalse = true;
        for(let i = 0; i < this.firstMapCall.length; i++) {
          if (this.firstMapCall[i].status === 'green') {
            checkboxFilterArray.push(this.firstMapCall[i]);
          }
        }
      } else if (this.checkboxesFilter[j].name === 'orange'
      && this.checkboxesFilter[j].selected){
        notAllAreFalse = true;
        for(let i = 0; i < this.firstMapCall.length; i++) {
          if (this.firstMapCall[i].status === 'orange') {
            checkboxFilterArray.push(this.firstMapCall[i]);
          }
        }
      } else if (this.checkboxesFilter[j].name === 'red'
      && this.checkboxesFilter[j].selected) {
        notAllAreFalse = true;
        for(let i = 0; i < this.firstMapCall.length; i++) {
          if (this.firstMapCall[i].status === 'red') {
            checkboxFilterArray.push(this.firstMapCall[i]);
          }
        }
      } else if (this.checkboxesFilter[j].name === 'gray'
      && this.checkboxesFilter[j].selected) {
        notAllAreFalse = true;
        for(let i = 0; i < this.firstMapCall.length; i++) {
          if (this.firstMapCall[i].status === 'gray') {
            checkboxFilterArray.push(this.firstMapCall[i]);
          }
        }
      }
    }
    this.globalMap = checkboxFilterArray;
    if (!notAllAreFalse) {
      this.globalMap = this.firstMapCall;
    }
    /*if (this.globalMap.length === 0) {
      this.globalMap = this.firstMapCall;
    }*/
  }

  checkIfBorderIsNeededRed(mapItem) {
    if(mapItem.status === 'red') {
      this.mapListModel.redMap.forEach((element, index) => {
        if(element === mapItem) {
          if(index === 1) {
            return true;
          } else {
            return false;
          }
        }
      });
    }

  }
  checkIfBorderIsNeededOrange(mapItem) {
    if(mapItem.status === 'orange') {
      this.mapListModel.orangeMap.forEach((element, index) => {
        if(element === mapItem) {
          if(index === this.mapListModel.orangeMap.length-1) {
            return true;
          } else {
            return false;
          }
        }
      });
    }

  }
}
